import { render, staticRenderFns } from "./statistic_platform_user.vue?vue&type=template&id=18f6efec&scoped=true"
import script from "./statistic_platform_user.vue?vue&type=script&lang=js"
export * from "./statistic_platform_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6efec",
  null
  
)

export default component.exports